(function () {
  function initVariantThumbScrollers(root) {
    const scope = root || document;
    const scrollers = scope.querySelectorAll('.product-variants--thumbnails');

    scrollers.forEach((scroller) => {
      if (scroller.dataset.pvtInit === 'true') return;
      scroller.dataset.pvtInit = 'true';

      // Create controls
      const controls = document.createElement('div');
      controls.className = 'pvt-scroll-controls';

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'pvt-scroll-btn pvt-scroll-btn--prev';
      prev.setAttribute('aria-label', 'Scroll variants previous');
      prev.textContent = '‹';

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'pvt-scroll-btn pvt-scroll-btn--next';
      next.setAttribute('aria-label', 'Scroll variants next');
      next.textContent = '›';

      controls.appendChild(prev);
      controls.appendChild(next);

      // Inject AFTER scroller (below)
      scroller.parentNode.insertBefore(controls, scroller.nextSibling);

      // Smooth scroll
      scroller.style.scrollBehavior = 'smooth';

      const getAxis = () => {
        const canScrollX = scroller.scrollWidth > scroller.clientWidth + 1;
        const canScrollY = scroller.scrollHeight > scroller.clientHeight + 1;
        return canScrollX ? 'x' : (canScrollY ? 'y' : 'x');
      };

      const getStep = () => {
        const firstItem = scroller.querySelector('.product-variant__item');
        if (firstItem) {
          const rect = firstItem.getBoundingClientRect();
          return getAxis() === 'x' ? rect.width : rect.height;
        }
        return 160;
      };

      const updateButtons = () => {
        const axis = getAxis();
        if (axis === 'x') {
          const max = scroller.scrollWidth - scroller.clientWidth;
          prev.disabled = scroller.scrollLeft <= 1;
          next.disabled = scroller.scrollLeft >= max - 1;
        } else {
          const max = scroller.scrollHeight - scroller.clientHeight;
          prev.disabled = scroller.scrollTop <= 1;
          next.disabled = scroller.scrollTop >= max - 1;
        }
      };

      const maybeHideControls = () => {
        const axis = getAxis();
        const hasOverflow =
          axis === 'x'
            ? scroller.scrollWidth > scroller.clientWidth + 1
            : scroller.scrollHeight > scroller.clientHeight + 1;

        controls.style.display = hasOverflow ? '' : 'none';
      };

      const scrollByStep = (dir) => {
        const axis = getAxis();
        const step = getStep();
        if (axis === 'x') {
          scroller.scrollBy({ left: dir * step, behavior: 'smooth' });
        } else {
          scroller.scrollBy({ top: dir * step, behavior: 'smooth' });
        }
      };

      // These closures capture *this* scroller only ✅
      prev.addEventListener('click', () => scrollByStep(-1));
      next.addEventListener('click', () => scrollByStep(1));
      scroller.addEventListener('scroll', updateButtons, { passive: true });

      // Update on resize for this instance
      const onResize = () => {
        maybeHideControls();
        updateButtons();
      };
      window.addEventListener('resize', onResize);

      // Initial state
      maybeHideControls();
      updateButtons();
    });
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => initVariantThumbScrollers(document));

  // Shopify theme editor / section reload support
  document.addEventListener('shopify:section:load', (event) => {
    initVariantThumbScrollers(event.target);
  });
  document.addEventListener('shopify:section:reorder', () => initVariantThumbScrollers(document));
})();